const SW_CLEANUP_KEY = "wlj-sw-cleanup-done";

/** Unregister legacy service workers once per browser session. */
export const cleanupLegacyServiceWorkers = () => {
  if (!("serviceWorker" in navigator)) return;
  if (sessionStorage.getItem(SW_CLEANUP_KEY)) return;

  sessionStorage.setItem(SW_CLEANUP_KEY, "1");
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });
};
